import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { InfoBeneficiarTypes, documentTypes, listTypes, customerTypes } from './types';
import { BeneficiarTypes } from 'redux/Api/beneficiariesApi/type';

interface StateType {
  infoBeneficiar: BeneficiarTypes;
  location: number;
}

const initialState: StateType = {
  infoBeneficiar: {
    features: {
      unitbased: false,
    },
    id: null,
    jur_name: '',
    jur_address: '',
    phone: '',
    email: '',
    ogrn: '',
    inn: '',
    kpp: '',
    lists: {
      available_tabs: [],
    },
    director: {
      email: '',
      fio: '',
      phone: '',
    },
    beneficiary: {
      document: {
        document_date: '',
        document_number: '',
        file: '',
        is_success_added: false,
      },
      is_active: false,
      updated_at: '',
    },
    commission: {
      min_amount: '',
      percent: '',
    },
    order_limits: {
      min: 0,
      max: 0,
    },
  },
  location: 0,
};

export const beneficiarSlice = createSlice({
  name: 'beneficiarSlice',
  initialState,
  reducers: {
    setInfoBeneficiar: (
      state,
      action: PayloadAction<{
        key: string;
        value: unknown;
        step?: boolean;
        secondKey?: string;
      }>,
    ) => {
      if (!action.payload.key) return;
      if (action.payload.step) {
        const { key, secondKey, value } = action.payload;

        if (
          secondKey &&
          typeof state.infoBeneficiar[key as keyof BeneficiarTypes] === 'object' &&
          state.infoBeneficiar[key as keyof BeneficiarTypes] !== null
        ) {
          const obj = state.infoBeneficiar[key as keyof BeneficiarTypes] as Record<
            string,
            unknown
          >;
          obj[secondKey] = value;
        }
      } else {
        const { key, value } = action.payload;
        (state.infoBeneficiar as Record<string, unknown>)[key] = value;
      }
    },
    setLocation: (state, action: PayloadAction<number>) => {
      state.location = action.payload;
    },
  },
});

export const { setInfoBeneficiar, setLocation } = beneficiarSlice.actions;
export default beneficiarSlice.reducer;
